export default {"src":"/_next/static/media/secured-data.011d5eb0.svg","height":221,"width":267,"blurWidth":0,"blurHeight":0};